import React from 'react'
import PropTypes from 'prop-types'
import { Empty, Slider, Icon } from 'antd'
import classnames from 'classnames'
import classNames from 'classnames'
import styles from './FilterBar.module.less'
import get from 'lodash/get'


/**
 * @typedef {import('@/types/search').FilterAggregation & {agg_key: string, agg_swi: boolean}} AggItem
 */


/**
 * @typedef {Object} AggBucketSelectObj
 * @property {string} query
 * @property {string} key
 * @property {string} parkey
 * @property {string} name
 * @property {string} bucket_name
 * @property {number} [gte]
 * @property {number} [lt]
 * @property {'rangeChange'} [changeType] 数据被触发的原因，目前只有价格滑块需要
 */

class FilterBar extends React.Component {
  state = {
    aggsArr: [],
    expandedGroupKeys: [],
    sliderKey: 1,
    sliderMin: '',
    sliderMax: '',
  }

  componentDidMount() {
    const { aggsData } = this.props
    let { expandedGroupKeys, sliderMin, sliderMax } = this.state
    const aggsArr = this.exchangeData(aggsData)
    aggsArr.forEach((item) => {
      if (item.agg_key === "price.min") {
        item.buckets.forEach((subItem) => {
          if (subItem.selected) {
            sliderMin = subItem.gte
            sliderMax = subItem.lt
          }
        })
      }
      if (get(item, 'buckets', []).some(i => i.selected) && !expandedGroupKeys.includes(item.name)) {
        expandedGroupKeys.push(item.name)
      }
    })
    this.setState({
      sliderMin,
      sliderMax,
      aggsArr,
      expandedGroupKeys: this.uniqArr(expandedGroupKeys)
    })
  }

  componentWillReceiveProps(nextProps) {
    const { aggsData } = nextProps
    let { sliderMin, sliderMax } = this.state
    sliderMin = ''
    sliderMax = ''
    if (aggsData && Object.keys(aggsData).length > 0) {
      const aggsArr = this.exchangeData(aggsData)
      aggsArr.forEach((item) => {
        if (item.agg_key === "price.min") {
          item.buckets.forEach((subItem) => {
            if (subItem.selected) {
              sliderMin = subItem.gte
              sliderMax = subItem.lt
            }
          })
        }
      })
      this.setState({
        sliderMin,
        sliderMax,
        aggsArr,
      })
    }
  }

  //数组去重
  uniqArr = (array) => {
    var temp = [];
    var index = [];
    var l = array.length;
    for (var i = 0; i < l; i++) {
      for (var j = i + 1; j < l; j++) {
        if (array[i] === array[j]) {
          i++;
          j = i;
        }
      }
      temp.push(array[i]);
      index.push(i);
    }
    return temp;
  }

  /**
 * exchangeData
 * @param {{[key:string]: import('@/types/search').FilterAggregation}} data
 * @return {AggItem[]}
 */
  exchangeData = (data) => {
    let aggsArr = []
    for (let key in data) {
      let _obj = data[key]
      _obj.agg_key = key
      _obj.agg_swi = false
      //aggsArr需要根据sort字段排序
      aggsArr.push(_obj)
    }
    //排序后的数组
    aggsArr = aggsArr.sort((a, b) => {
      return a.agg_sort - b.agg_sort
    })
    return aggsArr
  }

  // 切换显示隐藏
  toggleItem = (_index) => {
    const { aggsArr } = this.state
    let expandedGroupKeys = [...this.state.expandedGroupKeys]
    const item = aggsArr[_index]
    if (!item) return
    const targetIndex = expandedGroupKeys.indexOf(item.name)
    if (targetIndex > -1) {
      expandedGroupKeys = expandedGroupKeys.filter((_, index) => index !== targetIndex)
    } else {
      expandedGroupKeys.push(item.name)
    }
    this.setState({ expandedGroupKeys: expandedGroupKeys })
  }

  //点击筛选项ui选中效果
  select = (selectObj) => {
    let { sliderKey, sliderMin, sliderMax } = this.state
    if (selectObj.parkey === "price.min") {
      sliderMin = `${selectObj.gte}`
      sliderMax = `${selectObj.lt}`
      sliderKey += 1
    }
    this.setState({
      sliderKey,
      sliderMin,
      sliderMax,
    }, () => {
      this.props.onSelectFilter(selectObj)
    })
  }

  /**
 * 范围滑块变化(目前只有价格范围)
 * @param {string} name
 * @param {{min: number, max: number}} value
 */
  handleRangeAggChange = (name, value) => {
    const { aggsArr } = this.state
    let { sliderMin, sliderMax } = this.state
    // /** @type {import('@/types/search').FilterAggregation} */
    const aggItem = aggsArr.find(i => i.name === name)
    if (!aggItem) return
    sliderMin = `${value.min}`
    sliderMax = `${value.max}`
    /**
     * @type {AggBucketSelectObj}
     */
    const selectObj = {
      name: aggItem.agg_name,
      query: aggItem.agg_query,
      bucket_name: `${value.min}-${value.max}`,
      parkey: aggItem.agg_key,
      gte: value.min,
      lt: value.max,
      key: `${value.min}-${value.max}`,
      changeType: 'rangeChange'
    }
    this.setState({
      sliderMin,
      sliderMax,
    }, () => {
      this.props.onSelectFilter(selectObj)
    })
  }

  sureFn = () => {
    this.props.onSureFN()
  }

  resetFn = () => {
    let { sliderKey, sliderMin, sliderMax } = this.state
    sliderKey += 1
    sliderMin = ''
    sliderMax = ''
    this.setState({
      sliderKey,
      sliderMin,
      sliderMax,
    }, () => {
      this.props.onResetFn()
    })
  }

  render() {
    const { aggsArr, expandedGroupKeys, sliderKey, sliderMin, sliderMax } = this.state
    const { num } = this.props
    return aggsArr && aggsArr.length > 0 ? (
      <div>
        <div className={styles.filterBar__sheetBar}>
          <div className={styles.filterBar__lists}>
            {aggsArr && aggsArr.length > 0 ? aggsArr.map((item, index) => {
              const isExpanded = expandedGroupKeys.indexOf(item.name) > -1
              const bucketsCount = item.buckets.length
              const buckets = isExpanded ? item.buckets : item.buckets.slice(0, 3)
              return (
                <div className={styles.item} style={{ cursor: 'pointer' }} key={item.agg_key}>
                  <div
                    onClick={() => { this.toggleItem(index) }}
                    className={classnames([styles.itemSelect, 'fl-row-justy'])}
                  >
                    <div className={classNames('fl-row-left')}>
                      <span className={styles.aggName}>{item.agg_name}</span>
                    </div>
                    <div>
                      {
                        bucketsCount > 3 ? (
                          <span className={styles.expandText}>{isExpanded ? '收起' : '更多'}</span>
                        ) : null
                      }
                      {
                        bucketsCount > 3 ? (
                          isExpanded ? <Icon type="up" /> : <Icon type="down" />
                        ) : null
                      }
                    </div>
                  </div>
                  {
                    item.agg_query === 'range' && item.name === 'price.min' ? (
                      <div key={`Price${sliderKey}`}>
                        <div className='fl-row-justy'>
                          <div className={styles.price_range}>¥{sliderMin ? parseInt(sliderMin) : parseInt(item.min)}</div>
                          <div className={styles.price_range}>¥{sliderMax ? parseInt(sliderMax) : parseInt(item.max)}</div>
                        </div>
                        <Slider
                          range
                          step={10}
                          min={parseInt(item.min)}
                          max={parseInt(item.max)}
                          defaultValue={[sliderMin ? parseInt(sliderMin) : parseInt(item.min), sliderMax ? parseInt(sliderMax) : parseInt(item.max)]}
                          onAfterChange={(value) => {
                            this.handleRangeAggChange(item.name, { min: value[0], max: value[1] })
                          }}
                        />
                      </div>
                    ) : null
                  }
                  <div className={classNames([styles.selectLis])}>
                    {buckets.map((subItem, subIndex) => {
                      return (
                        <div
                          key={subItem.key}
                          style={{marginRight: `${(subIndex + 1) % 3 === 0 ? '0px' : '8px'}`}}
                          className={classNames([styles.itemBar], { [styles.active]: subItem.selected })}
                          onClick={() => {
                            this.select({
                              query: (subItem.agg_query ? subItem.agg_query : item.agg_query),
                              key: subItem.key,
                              parkey: (subItem.agg_key ? subItem.agg_key : item.agg_key),
                              gte: (item.agg_query === 'range' ? subItem.gte : ''),
                              lt: (item.agg_query === 'range' ? subItem.lt : ''),
                              name: item.agg_name,
                              bucket_name: item.bucket_name
                            })
                          }}
                        >
                          <div className={styles.txt}>
                            {subItem.bucket_name}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })
              : null}
          </div>
        </div>
        <div className={classnames([styles.filterBar__footer, 'fl-row-justy'])}>
          <div onClick={this.resetFn} className={classnames([styles.sigo_button, styles.sigo_button__border])}>
            重置
          </div>
          <div onClick={this.sureFn} className={classnames([styles.sigo_button, styles.sigo_button__primary])}>
            确定（{num}）
          </div>
        </div>
      </div>
    ) : <Empty></Empty>
  }
}

FilterBar.propTypes = {
  aggsData: PropTypes.object,
  num: PropTypes.number,
  onSelectFilter: PropTypes.func,
  onResetFn: PropTypes.func,
  onSureFN: PropTypes.func,
};

export default FilterBar



// WEBPACK FOOTER //
// ./src/pages/udeskSide/components/FilterBar.js